import React, { Component } from "react";

import { ActivityLogConsumer } from "../context/activity-log-context";

import "../styles/expander.scss";

export default class Expander extends Component {
  constructor(props) {
    super();

    this.state = {
      isExpanded: props.isExpanded || false,
      isFirstOpened: true,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  checkIfHasNotifications = (contextState, quoteId) => {
    let notifications = contextState.getQuoteNotifications(quoteId);
    let notificationsAmount = notifications.length;

    if (notificationsAmount === 0) {
      this.setState({ isExpanded: true, isFirstOpened: false });
    }
  };

  render() {
    const { isPolicy, quoteId, title, icon, children } = this.props;

    return (
      <ActivityLogConsumer>
        {(contextState) => {
          if (quoteId && !isPolicy && this.state.isFirstOpened) {
            this.checkIfHasNotifications(contextState, quoteId);
          }

          return (
            <div className="expander">
              <div className="expander-header">
                <div className={`expander-icon ${icon || ""}`} />
                <div className="expander-title">{title || ""}</div>
                <div
                  className={`expander-button${
                    this.state.isExpanded ? " expanded" : ""
                  }`}
                  onClick={this.toggle}
                />
              </div>
              <div className="expander-content" hidden={this.state.isExpanded}>
                {children}
              </div>
            </div>
          );
        }}
      </ActivityLogConsumer>
    );
  }
}
